export enum Method {
  Z_TEST = 'Z_TEST',
  GST_Z_TEST = 'GST_Z_TEST',
  ASYMP_CS = 'ASYMP_CS',
  RATIO = 'RATIO',
  GST_RATIO = 'GST_RATIO',
  ASYMP_CS_RATIO = 'ASYMP_CS_RATIO',
  UNKNOWN = 'UNKNOWN',
}

export enum MetricKind {
  SUCCESS = 'SUCCESS',
  GUARDRAIL = 'GUARDRAIL',
}
